module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Bold.d0956012.woff2";